import React from "react";

function AgencyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <path
        fill="#FFF"
        d="M8.118 10.536l4.393-4.365 1.89 1.89-4.364 4.393a.418.418 0 01-.306.112H8.007v-1.724c0-.111.028-.223.111-.306zm7.673-4.865a.705.705 0 010 1l-.75.751-1.89-1.89.75-.75a.705.705 0 011 0l.89.889zM7.117 1l3.559 3.559H7.117V1zm0 12.455h3.559v.445c0 .75-.612 1.335-1.335 1.335H1.334C.584 15.235 0 14.65 0 13.9V2.334C0 1.612.584 1 1.334 1h4.894v3.559c0 .5.389.89.89.89h3.558v1.306l-3.308 3.28a.862.862 0 00-.25.612v1.919a.306.306 0 01-.279-.167c-.333-.667-1.279-.834-1.835-.39l-.389-1.167a.626.626 0 00-.612-.445c-.305 0-.556.167-.639.445l-.5 1.529a.342.342 0 01-.306.195h-.334a.457.457 0 00-.445.444c0 .25.195.445.445.445h.334c.528 0 .973-.306 1.14-.806l.305-.89.445 1.39a.41.41 0 00.39.306h.055a.479.479 0 00.39-.222l.222-.445c.055-.139.194-.167.278-.167.055 0 .194.028.278.195.194.389.584.64 1.056.64z"
      ></path>
    </svg>
  );
}

export default React.memo(AgencyIcon);
